/**
 * Search Process Handlers
 *
 * Global and domain-specific search handlers
 */

import { handleRequest } from './config'
import { mockData } from '../mocks'
import { ApiResponse, User, Session } from '../types'

// ========================================
// SEARCH HANDLERS
// ========================================

/**
 * Global search across all entities
 */
export interface GlobalSearchResult {
  users: User[]
  sessions: Session[]
  teams: unknown[]
}

export const globalSearch = async (query: string): Promise<ApiResponse<GlobalSearchResult>> => {
  return handleRequest(
    () =>
      Promise.resolve({
        data: {
          users: mockData.users.filter((u) => u.name.toLowerCase().includes(query.toLowerCase())),
          sessions: mockData.sessions.filter((s) => s.title.toLowerCase().includes(query.toLowerCase())),
          teams: mockData.teams.filter((t) => t.name.toLowerCase().includes(query.toLowerCase()))
        },
        success: true
      } as ApiResponse<GlobalSearchResult>),
    async () => {
      // TODO: Implement cloud function
      return { data: { users: [], sessions: [], teams: [] }, success: true }
    }
  )
}

/**
 * Search users by query
 */
export const searchUsers = async (query: string): Promise<ApiResponse<User[]>> => {
  return handleRequest(
    () =>
      Promise.resolve({
        data: mockData.users.filter((u) => u.name.toLowerCase().includes(query.toLowerCase())),
        success: true
      } as ApiResponse<User[]>),
    async () => {
      // TODO: Implement cloud function
      return { data: [], success: true }
    }
  )
}

/**
 * Search sessions by query
 */
export const searchSessions = async (query: string): Promise<ApiResponse<Session[]>> => {
  return handleRequest(
    () =>
      Promise.resolve({
        data: mockData.sessions.filter((s) => s.title.toLowerCase().includes(query.toLowerCase())),
        success: true
      } as ApiResponse<Session[]>),
    async () => {
      // TODO: Implement cloud function
      return { data: [], success: true }
    }
  )
}
